export const DASHBOARD_FOURNISSEUR = {
    SET_STATS: 'SET_STATS',
    SET_DERNIERS_REGLEMENTS: 'SET_DERNIERS_REGLEMENTS'
};
